import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { Tabs } from 'antd'

import { useMenu, useUser } from 'data/hooks'

export const TabsMenu = props => {

  const { slug } = props
  const { menu } = useMenu(slug)
  const { userId } = useUser()
  const [ current, setCurrent ] = useState()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()


  const getLink = menuOption => {

    const url = menuOption.link.split("/")
                          .map(key => {
                            switch(key) {
                              case ":menuId": return menuOption.id
                              case ":userId": return userId
                              case ":gameId": return playmotiv.game.gameId
                            }
                            return params[key] ? params[key] : key
                          })
                          .join("/")
    return url
  }

  useEffect(() => {

    if (!menu) return
    const pathname = location.pathname
    const option = menu.filter(option => pathname.startsWith(getLink(option.data)))
                      .sort((a, b) => b.data.link.length - a.data.link.length)
                      .shift()

    if (option) setCurrent(option.key)

  }, [menu])


  const onChange = (selectedKey) => {

    setCurrent(selectedKey)

    const menuOption = menu[selectedKey].data
    const url = getLink(menuOption)
    
    if (url.indexOf('http') > -1) {
      document.location = url
    } else {
      navigate(url)
    }
  };

  return (<>
    { menu && 
      <Tabs 
        { ...props }
        onChange={onChange}
        activeKey={current}
        items={menu}
      />
    }
  </>)
}